import { PaginationParams } from 'src/app/core/interfaces';
import { PaymentChannelType } from '../..';

export class GetConsumerEligibilityParams extends PaginationParams {
  msisdn?: string;
  consumerIdentityUuid?: string;
  iccid?: string;
  lineId?: string;
  paymentChannelTypes?: PaymentChannelType[];
  includeNotPurchasablePlans?: boolean;
}
